/**
 * Saves a blob to the user's downloads via a programmatic anchor click.
 *
 * The anchor has to be in the document for Firefox to dispatch the click, and
 * the object URL has to outlive the click — revoking it synchronously cancels
 * the download in some browsers — so the revoke is deferred a tick.
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  setTimeout(() => URL.revokeObjectURL(url), 0);
}
